import WorkbookControlVM from './WorkbookControlVM'

export default class DataViewVM extends WorkbookControlVM {
    constructor(data?: any) {
        super(data);
    }
}